'use client';

import { useEffect } from 'react';
import { Study } from '@/lib/study';
import { T } from '@/lib/tokens';
import { Nav, StepHead, StepWrap } from '../StepShell';
import { Textarea } from '../Textarea';

const DEFAULT_CLOSING = `Thank you so much for sharing your thoughts and experiences with me today. Your responses are incredibly valuable to this research.

This concludes our interview. The conversation will now be saved. If you have any questions about the study, please feel free to reach out to the research team.

Thank you again for your time.`;

type Props = {
  data: Study;
  setData: (d: Study) => void;
  onBack: () => void;
  onNext: () => void;
};

export function Step9Closing({ data, setData, onBack, onNext }: Props) {
  useEffect(() => {
    if (!data.closing) setData({ ...data, closing: DEFAULT_CLOSING });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StepWrap>
      <StepHead
        label="Step 10 — Closing"
        title="How should the interview end?"
        subtitle="Write the closing message the AI will read after the last question. Thank participants, signal the end of the session, and let them know what happens next."
      />
      <Textarea
        value={data.closing || DEFAULT_CLOSING}
        onChange={(v) => setData({ ...data, closing: v })}
        rows={8}
        label="Closing message"
        helper="This will be read aloud by the AI interviewer at the end of each session."
      />
      <div
        style={{
          background: T.terraLight,
          border: `1px solid ${T.terraMid}`,
          borderRadius: 10,
          padding: '12px 16px',
          fontSize: 13,
          color: T.espressoMid,
        }}
      >
        <strong style={{ color: T.espresso }}>Tip:</strong>{' '}
        Let participants know if they&apos;ll be contacted again, how their
        data will be used, or who to reach out to with questions.
      </div>
      <Nav onBack={onBack} onNext={onNext} nextDisabled={!data.closing?.trim()} />
    </StepWrap>
  );
}
